import { compareBrowserVersion } from '@umu/umu-ua';
import { getData, statistic } from '@umu/umu-util';

export const isSupportRecord = (type: 'pc' | 'mobile' = 'pc') => {
    const browserSupportMap: any = {
        chrome: {
            pc: '42.0.0',
            mobile: '42.0.0',
        },
        firefox: {
            pc: '45.0.0',
            mobile: '45.0.0',
        },
        safari: {
            pc: '15.6.0',
            mobile: '15.7.0',
        },
        edge: {
            pc: '18.0.0',
            mobile: '18.0.0',
        },
    };

    // 检查浏览器兼容性
    const browserInfo = getData(statistic, 'browserInfo') || {};
    const browserName = browserInfo.appName;
    const browserNameLowerCase = browserName.toLowerCase();
    let isSupportVersion = false;
    if (browserSupportMap[browserNameLowerCase] && browserSupportMap[browserNameLowerCase][type]) {
        isSupportVersion =
            compareBrowserVersion(browserInfo.appVersion, browserSupportMap[browserNameLowerCase][type]) >= 0;
    }
    return isSupportVersion;
};
